import { Reducer } from 'redux';
import { IFiltersState, FiltersActionTypes } from './types';
import { filtersService } from './service';

const initialState: IFiltersState = filtersService.getFilters();

const reducer: Reducer<IFiltersState> = (state = initialState, action) => {
  switch (action.type) {
    case FiltersActionTypes.ADD_EXPANDED: {
      const expanded = state.expanded ?? [];
      const newState = { ...state, expanded: [...expanded, action.payload] };
      filtersService.saveFilters(newState);
      return newState;
    }
    case FiltersActionTypes.REMOVE_EXPANDED: {
      const expanded = state.expanded ?? [];
      const newState = { ...state, expanded: expanded.filter(expanded => expanded !== action.payload) };
      filtersService.saveFilters(newState);
      return newState;
    }
    case FiltersActionTypes.SAVE_SEARCH_VALUE: {
      const newState = { ...state, savedSearchValue: action.payload };
      filtersService.saveFilters(newState);
      return newState;
    }
    default:
      return state;
  }
};
export { reducer as filtersReducer };
